var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"skipTo",staticClass:"vue-skip-to",class:{ 'focused': _vm.focused }},[_c(_vm.comp,_vm._b({tag:"component",on:{"focused":_vm.focusWithin,"focus-within":_vm.focusWithin}},'component',_vm.props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }